module.exports = __webpack_public_path__ + "img/hr-rock-big-12.c4752a3f.png";